export interface PostalCodeValidation {
  country: string
  regex: RegExp
  errorMessage: string
}

export const POSTAL_CODE_VALIDATIONS: Record<string, PostalCodeValidation> = {
  Bhutan: {
    country: 'Bhutan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Bhutan, Bhutan postal code must be in 99999 format. Example: 21001',
  },
  Chad: {
    country: 'Chad',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Chad, Chad postal code must be in 99999 format. Example: 10000',
  },
  China: {
    country: 'China',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country China, China postal code must be in 999999 format. Example: 100000',
  },
  'Christmas Island': {
    country: 'Christmas Island',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Christmas Island, Christmas Island postal code must be in 9999 format. Example: 6798',
  },
  'Cocos (Keeling) Islands': {
    country: 'Cocos (Keeling) Islands',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Cocos (Keeling) Islands, Cocos (Keeling) Islands postal code must be in 9999 format. Example: 6799',
  },
  'Bosnia and Herzegovina': {
    country: 'Bosnia and Herzegovina',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Bosnia and Herzegovina, Bosnia and Herzegovina postal code must be in 99999 format. Example: 71000',
  },
  Brazil: {
    country: 'Brazil',
    regex: /^\d{5}(-\d{3})?$/,
    errorMessage:
      'The postal code is invalid for country Brazil, Brazil postal code must be in 99999 OR 99999-999 format. Example: 01001 OR 01001-000',
  },
  India: {
    country: 'India',
    regex: /^\d{3}\s?\d{3}$/,
    errorMessage:
      'The postal code is invalid for country India, India postal code must be in 999999 OR 999 999 format. Example: 110001 OR 110 001',
  },
  Indonesia: {
    country: 'Indonesia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Indonesia, Indonesia postal code must be in 99999 format. Example: 10110',
  },
  Ireland: {
    country: 'Ireland',
    regex: /^[A-Za-z]\d[\dWw]\s?[A-Za-z\d]{4}$/,
    errorMessage:
      'The postal code is invalid for country Ireland, Ireland postal code must be in A99 9A9A or A999A9A format. Example: D02 Y006 or D02Y006',
  },
  Jordan: {
    country: 'Jordan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Jordan, Jordan postal code must be in 99999 format. Example: 11110',
  },
  Kazakhstan: {
    country: 'Kazakhstan',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Kazakhstan, Kazakhstan postal code must be in 999999 format. Example: 010000',
  },
  Kenya: {
    country: 'Kenya',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Kenya, Kenya postal code must be in 99999 format. Example: 00100',
  },
  Korea: {
    country: 'Korea',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Korea, Korea postal code must be in 99999 format. Example: 03051',
  },
  Kuwait: {
    country: 'Kuwait',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Kuwait, Kuwait postal code must be in 99999 format. Example: 13001',
  },
  Kyrgyzstan: {
    country: 'Kyrgyzstan',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Kyrgyzstan, Kyrgyzstan postal code must be in 999999 format. Example: 720001',
  },
  Israel: {
    country: 'Israel',
    regex: /^\d{5}(\d{2})?$/,
    errorMessage:
      'The postal code is invalid for country Israel, Israel postal code must be in 99999 OR 9999999 format. Example: 61000 OR 6100000',
  },
  Italy: {
    country: 'Italy',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Italy, Italy postal code must be in 99999 format. Example: 00100',
  },
  Jamaica: {
    country: 'Jamaica',
    regex: /^\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Jamaica, Jamaica postal code must be in 99 format. Example: 01',
  },
  Japan: {
    country: 'Japan',
    regex: /^\d{3}-?\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Japan, Japan postal code must be in 9999999 OR 999-9999 format. Example: 1000001 OR 100-0001',
  },
  'Brunei Darussalam': {
    country: 'Brunei Darussalam',
    regex: /^[A-Z]{2}\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Brunei Darussalam, Brunei Darussalam postal code must be in KB9999 format. Example: KB2345',
  },
  Colombia: {
    country: 'Colombia',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Colombia, Colombia postal code must be in 999999 format. Example: 110111',
  },
  'Costa Rica': {
    country: 'Costa Rica',
    regex: /^\d{4,5}$/,
    errorMessage:
      'The postal code is invalid for country Costa Rica, Costa Rica postal code must be in 9999 or 99999 format. Example: 1000 or 10101',
  },
  "Lao People's Democratic Republic": {
    country: "Lao People's Democratic Republic",
    regex: /^\d{5}$/,
    errorMessage:
      "The postal code is invalid for country Lao People's Democratic Republic, Lao People's Democratic Republic postal code must be in 99999 format. Example: 01000",
  },
  Lesotho: {
    country: 'Lesotho',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Lesotho, Lesotho postal code must be in 999 format. Example: 100',
  },
  Liberia: {
    country: 'Liberia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Liberia, Liberia postal code must be in 9999 format. Example: 1000',
  },
  Liechtenstein: {
    country: 'Liechtenstein',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Liechtenstein, Liechtenstein postal code must be in 9999 format. Example: 9490',
  },
  Lithuania: {
    country: 'Lithuania',
    regex: /^(LT-)?\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Lithuania, Lithuania postal code must be in 99999 or LT-99999 format. Example: 01001 or LT-01001',
  },
  Algeria: {
    country: 'Algeria',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Algeria, Algeria postal code must be in 99999 format. Example: 16000',
  },
  Armenia: {
    country: 'Armenia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Armenia, Armenia postal code must be in 9999 format. Example: 0010',
  },
  Ukraine: {
    country: 'Ukraine',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Ukraine, Ukraine postal code must be in 99999 format. Example: 01001',
  },
  Australia: {
    country: 'Australia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Australia, Australia postal code must be in 9999 format. Example: 2000',
  },
  Austria: {
    country: 'Austria',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Austria, Austria postal code must be in 9999 format. Example: 1010',
  },
  Bahrain: {
    country: 'Bahrain',
    regex: /^\d{3,4}$/,
    errorMessage:
      'The postal code is invalid for country Bahrain, Bahrain postal code must be in 999 OR 9999 format. Example: 973 OR 1216',
  },
  Cuba: {
    country: 'Cuba',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Cuba, Cuba postal code must be in 99999 format. Example: 10400',
  },
  Afghanistan: {
    country: 'Afghanistan',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Afghanistan, Afghanistan postal code must be in 9999 format. Example: 1001',
  },
  'Aland Islands': {
    country: 'Aland Islands',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Aland Islands, Aland Islands postal code must be in 99999 format. Example: 22101',
  },
  'Saint Barthelemy': {
    country: 'Saint Barthelemy',
    regex: /^97133$/,
    errorMessage:
      'The postal code is invalid for country Saint Barthelemy, Saint Barthelemy postal code must be in 97133 format. Example: 97133',
  },
  Bangladesh: {
    country: 'Bangladesh',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Bangladesh, Bangladesh postal code must be in 9999 format. Example: 1205',
  },
  Iraq: {
    country: 'Iraq',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Iraq, Iraq postal code must be in 99999 format. Example: 10001',
  },
  Montenegro: {
    country: 'Montenegro',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Montenegro, Montenegro postal code must be in 99999 format. Example: 81000',
  },
  'Saint Martin (French Part)': {
    country: 'Saint Martin (French Part)',
    regex: /^97150$/,
    errorMessage:
      'The postal code is invalid for country Saint Martin (French Part ), Saint Martin (French Part ) postal code must be in 97150 format. Example: 97150',
  },
  Belgium: {
    country: 'Belgium',
    regex: /^(B-\d{4}|\d{4})$/,
    errorMessage:
      'The postal code is invalid for country Belgium, Belgium postal code must be in B-9999 or 9999 format. Example: B-1000 or 1000',
  },
  Bermuda: {
    country: 'Bermuda',
    regex: /^[A-Z]{2}\s?(\d{2}|[A-Z]{2})$/,
    errorMessage:
      'The postal code is invalid for country Bermuda, Bermuda postal code must be in AA 99 OR AA AA format. Example: HM 11 OR HM EX',
  },
  Serbia: {
    country: 'Serbia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Serbia, Serbia postal code must be in 99999 format. Example: 11000',
  },
  'Svalbard and Jan Mayen': {
    country: 'Svalbard and Jan Mayen',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Svalbard and Jan Mayen, Svalbard and Jan Mayen postal code must be in 9999 format. Example: 9170',
  },
  'Wallis and Futuna': {
    country: 'Wallis and Futuna',
    regex: /^986\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Wallis and Futuna, Wallis and Futuna postal code must be in 986NN format. Example: 98600',
  },
  Sudan: {
    country: 'Sudan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Sudan, Sudan postal code must be in 99999 format. Example: 11111',
  },
  'South Sudan': {
    country: 'South Sudan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country South Sudan, South Sudan postal code must be in 99999 format. Example: 11111',
  },
  'Czech Republic': {
    country: 'Czech Republic',
    regex: /^\d{3}\s?\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Czech Republic, Czech Republic postal code must be in 999 99 or 99999 format. Example: 110 00 or 11000',
  },
  Denmark: {
    country: 'Denmark',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Denmark, Denmark postal code must be in 9999 format. Example: 1050',
  },
  Bulgaria: {
    country: 'Bulgaria',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Bulgaria, Bulgaria postal code must be in 9999 format. Example: 1000',
  },
  Cambodia: {
    country: 'Cambodia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Cambodia, Cambodia postal code must be in 99999 format. Example: 12000',
  },
  Canada: {
    country: 'Canada',
    regex: /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/,
    errorMessage:
      'The postal code is invalid for country Canada, Canada postal code must be in A9A 9A9 or A9A9A9 format. Example: K1A 0B1 or K1A0B1',
  },
  'Cape Verde': {
    country: 'Cape Verde',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Cape Verde, Cape Verde postal code must be in 9999 format. Example: 7600',
  },
  Croatia: {
    country: 'Croatia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Croatia, Croatia postal code must be in 99999 format. Example: 10000',
  },
  Cyprus: {
    country: 'Cyprus',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Cyprus, Cyprus postal code must be in 9999 format. Example: 1010',
  },
  'Dominican Republic': {
    country: 'Dominican Republic',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Dominican Republic, Dominican Republic postal code must be in 99999 format. Example: 10101',
  },
  Mozambique: {
    country: 'Mozambique',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Mozambique, Mozambique postal code must be in 9999 format. Example: 1100',
  },
  Malta: {
    country: 'Malta',
    regex: /^[A-Za-z]{3}\s?\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Malta, Malta postal code must be in AAA 9999 or AAA9999 format. Example: MST 1000 or MST1000',
  },
  Myanmar: {
    country: 'Myanmar',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Myanmar, Myanmar postal code must be in 99999 format. Example: 11121',
  },
  Namibia: {
    country: 'Namibia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Namibia, Namibia postal code must be in 99999 format. Example: 10001',
  },
  Nepal: {
    country: 'Nepal',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Nepal, Nepal postal code must be in 99999 format. Example: 44600',
  },
  Luxembourg: {
    country: 'Luxembourg',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Luxembourg, Luxembourg postal code must be in 9999 format. Example: 1009',
  },
  'Macedonia, The former Yugoslav Republic Of': {
    country: 'Macedonia, The former Yugoslav Republic Of',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Macedonia, The former Yugoslav Republic Of, Macedonia, The former Yugoslav Republic Of postal code must be in 9999 format. Example: 1000',
  },
  Madagascar: {
    country: 'Madagascar',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Madagascar, Madagascar postal code must be in 999 format. Example: 101',
  },
  Malaysia: {
    country: 'Malaysia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Malaysia, Malaysia postal code must be in 99999 format. Example: 50000',
  },
  Morocco: {
    country: 'Morocco',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Morocco, Morocco postal code must be in 99999 format. Example: 10000',
  },
  Maldives: {
    country: 'Maldives',
    regex: /^\d{4,5}$/,
    errorMessage:
      'The postal code is invalid for country Maldives, Maldives postal code must be in 9999 OR 99999 format. Example: 2002 OR 20002',
  },
  Netherlands: {
    country: 'Netherlands',
    regex: /^\d{4}\s?[A-Za-z]{2}$/,
    errorMessage:
      'The postal code is invalid for country Netherlands, Netherlands postal code must be in 9999 AC or 9999AC format. Example: 1012 AC or 1012AC',
  },
  'New Caledonia': {
    country: 'New Caledonia',
    regex: /^988\d{2}$/,
    errorMessage:
      'The postal code is invalid for country New Caledonia, New Caledonia postal code must be in 988NN format. Example: 98800',
  },
  Turkey: {
    country: 'Turkey',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Turkey, Turkey postal code must be in 99999 format. Example: 06010',
  },
  Turkmenistan: {
    country: 'Turkmenistan',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Turkmenistan, Turkmenistan postal code must be in 999999 format. Example: 744000',
  },
  Greece: {
    country: 'Greece',
    regex: /^\d{3}\s?\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Greece, Greece postal code must be in 99999 OR 999 99 format. Example: 10431 OR 104 31',
  },
  Iceland: {
    country: 'Iceland',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Iceland, Iceland postal code must be in 999 format. Example: 101',
  },
  'Guinea-Bissau': {
    country: 'Guinea-Bissau',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Guinea-Bissau, Guinea-Bissau postal code must be in 9999 format. Example: 1000',
  },
  Haiti: {
    country: 'Haiti',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Haiti, Haiti postal code must be in 9999 format. Example: 6110',
  },
  Honduras: {
    country: 'Honduras',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Honduras, Honduras postal code must be in 99999 format. Example: 11101',
  },
  Senegal: {
    country: 'Senegal',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Senegal, Senegal postal code must be in 99999 format. Example: 10200',
  },
  'Serbia and Montenegro': {
    country: 'Serbia and Montenegro',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Serbia and Montenegro, Serbia and Montenegro postal code must be in 99999 format. Example: 11000',
  },
  Singapore: {
    country: 'Singapore',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Singapore, Singapore postal code must be in 999999 format. Example: 018956',
  },
  Slovakia: {
    country: 'Slovakia',
    regex: /^\d{3}\s?\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Slovakia, Slovakia postal code must be in 999 99 or 99999 format. Example: 811 01 or 81101',
  },
  'South Africa': {
    country: 'South Africa',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country South Africa, South Africa postal code must be in 9999 format. Example: 0001',
  },
  Guam: {
    country: 'Guam',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Guam, Guam postal code must be in 99999 format. Example: 96910',
  },
  Georgia: {
    country: 'Georgia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Georgia, Georgia postal code must be in 9999 format. Example: 0105',
  },
  Hungary: {
    country: 'Hungary',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Hungary, Hungary postal code must be in 9999 format. Example: 1011',
  },
  'Great Britain': {
    country: 'Great Britain',
    regex: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/,
    errorMessage:
      'The postal code is invalid for country Great Britain, Great Britain postal code must be in DT3 6GB OR L2 2DP format. Example: DT3 6GB OR L2 2DP',
  },
  Romania: {
    country: 'Romania',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Romania, Romania postal code must be in 999999 format. Example: 010011',
  },
  'Saint Vincent and the Grenadines': {
    country: 'Saint Vincent and the Grenadines',
    regex: /^VC\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Saint Vincent and the Grenadines, Saint Vincent and the Grenadines postal code must be in VC9999 format. Example: VC0100',
  },
  France: {
    country: 'France',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country France, France postal code must be in 99999 format. Example: 75001',
  },
  'French Guiana': {
    country: 'French Guiana',
    regex: /^973\d{2}$/,
    errorMessage:
      'The postal code is invalid for country French Guiana, French Guiana postal code must be in 973NN format. Example: 97300',
  },
  'French Polynesia': {
    country: 'French Polynesia',
    regex: /^987\d{2}$/,
    errorMessage:
      'The postal code is invalid for country French Polynesia, French Polynesia postal code must be in 987NN format. Example: 98714',
  },
  Guatemala: {
    country: 'Guatemala',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Guatemala, Guatemala postal code must be in 99999 format. Example: 01001',
  },
  Germany: {
    country: 'Germany',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Germany, Germany postal code must be in 99999 format. Example: 10115',
  },
  Peru: {
    country: 'Peru',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Peru, Peru postal code must be in 99999 format. Example: 15001',
  },
  Philippines: {
    country: 'Philippines',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Philippines, Philippines postal code must be in 9999 format. Example: 1000',
  },
  Poland: {
    country: 'Poland',
    regex: /^\d{2}-\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Poland, Poland postal code must be in 99-999 format. Example: 00-001',
  },
  Portugal: {
    country: 'Portugal',
    regex: /^\d{4}(-\d{3})?$/,
    errorMessage:
      'The postal code is invalid for country Portugal, Portugal postal code must be in 9999 OR 9999-999 format. Example: 1000 OR 1000-001',
  },
  'San Marino': {
    country: 'San Marino',
    regex: /^4789\d$/,
    errorMessage:
      'The postal code is invalid for country San Marino, San Marino postal code must be in 4789N format. Example: 47890',
  },
  'Saudi Arabia': {
    country: 'Saudi Arabia',
    regex: /^\d{5}-\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Saudi Arabia, Saudi Arabia postal code must be in 99999-9999 format. Example: 11564-7450',
  },
  Ecuador: {
    country: 'Ecuador',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Ecuador, Ecuador postal code must be in 999999 format. Example: 170150',
  },
  Egypt: {
    country: 'Egypt',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Egypt, Egypt postal code must be in 99999 format. Example: 11511',
  },
  'El Salvador': {
    country: 'El Salvador',
    regex: /^1101$/,
    errorMessage:
      'The postal code is invalid for country El Salvador, El Salvador postal code must be in 1101 format. Example: 1101',
  },
  Estonia: {
    country: 'Estonia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Estonia, Estonia postal code must be in 99999 format. Example: 10111',
  },
  Ethiopia: {
    country: 'Ethiopia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Ethiopia, Ethiopia postal code must be in 9999 format. Example: 1000',
  },
  Greenland: {
    country: 'Greenland',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Greenland, Greenland postal code must be in 9999 format. Example: 3900',
  },
  Guadeloupe: {
    country: 'Guadeloupe',
    regex: /^971\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Guadeloupe, Guadeloupe postal code must be in 971NN format. Example: 97100',
  },
  Norway: {
    country: 'Norway',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Norway, Norway postal code must be in 9999 format. Example: 0001',
  },
  Oman: {
    country: 'Oman',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Oman, Oman postal code must be in 999 format. Example: 100',
  },
  Pakistan: {
    country: 'Pakistan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Pakistan, Pakistan postal code must be in 99999 format. Example: 44000',
  },
  'Puerto Rico': {
    country: 'Puerto Rico',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Puerto Rico, Puerto Rico postal code must be in 99999 format. Example: 00901',
  },
  Reunion: {
    country: 'Reunion',
    regex: /^974\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Reunion, Reunion postal code must be in 974NN format. Example: 97400',
  },
  'Faroe Islands': {
    country: 'Faroe Islands',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Faroe Islands, Faroe Islands postal code must be in 999 format. Example: 100',
  },
  Monaco: {
    country: 'Monaco',
    regex: /^980\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Monaco, Monaco postal code must be in 980NN format. Example: 98000',
  },
  Mongolia: {
    country: 'Mongolia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Mongolia, Mongolia postal code must be in 99999 format. Example: 14200',
  },
  Niger: {
    country: 'Niger',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Niger, Niger postal code must be in 9999 format. Example: 8000',
  },
  Nigeria: {
    country: 'Nigeria',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Nigeria, Nigeria postal code must be in 999999 format. Example: 900001',
  },
  'Norfolk Island': {
    country: 'Norfolk Island',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Norfolk Island, Norfolk Island postal code must be in 9999 format. Example: 2899',
  },
  'Northern Mariana Islands': {
    country: 'Northern Mariana Islands',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Northern Mariana Islands, Northern Mariana Islands postal code must be in 99999 format. Example: 96950',
  },
  Palau: {
    country: 'Palau',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Palau, Palau postal code must be in 99999 format. Example: 96940',
  },
  Panama: {
    country: 'Panama',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Panama, Panama postal code must be in 999999 format. Example: 010101',
  },
  'Papua New Guinea': {
    country: 'Papua New Guinea',
    regex: /^\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Papua New Guinea, Papua New Guinea postal code must be in 999 format. Example: 111',
  },
  Paraguay: {
    country: 'Paraguay',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Paraguay, Paraguay postal code must be in 9999 format. Example: 1209',
  },
  Finland: {
    country: 'Finland',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Finland, Finland postal code must be in 99999 format. Example: 00100',
  },
  'New Zealand': {
    country: 'New Zealand',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country New Zealand, New Zealand postal code must be in 9999 format. Example: 6011',
  },
  Nicaragua: {
    country: 'Nicaragua',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Nicaragua, Nicaragua postal code must be in 99999 format. Example: 11001',
  },
  'Marshall Islands': {
    country: 'Marshall Islands',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Marshall Islands, Marshall Islands postal code must be in 99999 format. Example: 96960',
  },
  Martinique: {
    country: 'Martinique',
    regex: /^972\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Martinique, Martinique postal code must be in 972NN format. Example: 97200',
  },
  Mayotte: {
    country: 'Mayotte',
    regex: /^976\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Mayotte, Mayotte postal code must be in 976NN format. Example: 97600',
  },
  Mexico: {
    country: 'Mexico',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Mexico, Mexico postal code must be in 99999 format. Example: 01000',
  },
  'United States': {
    country: 'United States',
    regex: /^\d{5}(-\d{4})?$/,
    errorMessage:
      'The postal code is invalid for country United States, United States postal code must be in 99999 OR 99999-9999 format. Example: 10001 OR 10001-1234',
  },
  Uruguay: {
    country: 'Uruguay',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Uruguay, Uruguay postal code must be in 99999 format. Example: 11000',
  },
  'Holy See (Vatican City State)': {
    country: 'Holy See (Vatican City State)',
    regex: /^00120$/,
    errorMessage:
      'The postal code is invalid for country Holy See (Vatican City State), Holy See (Vatican City State) postal code must be in 120 format. Example: 120',
  },
  'Viet Nam': {
    country: 'Viet Nam',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Viet Nam, Viet Nam postal code must be in 999999 format. Example: 100000',
  },
  'VIRGIN ISLANDS, U.S.': {
    country: 'VIRGIN ISLANDS, U.S.',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country VIRGIN ISLANDS, U.S., VIRGIN ISLANDS, U.S. postal code must be in 99999 format. Example: 00801',
  },
  Zambia: {
    country: 'Zambia',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Zambia, Zambia postal code must be in 99999 format. Example: 10101',
  },
  Albania: {
    country: 'Albania',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Albania, Albania postal code must be in 9999 format. Example: 1001',
  },
  Spain: {
    country: 'Spain',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Spain, Spain postal code must be in 99999 format. Example: 28001',
  },
  'Sri Lanka': {
    country: 'Sri Lanka',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Sri Lanka, Sri Lanka postal code must be in 99999 format. Example: 10100',
  },
  'Saint Pierre and Miquelon': {
    country: 'Saint Pierre and Miquelon',
    regex: /^97500$/,
    errorMessage:
      'The postal code is invalid for country Saint Pierre and Miquelon, Saint Pierre and Miquelon postal code must be in 97500 format. Example: 97500',
  },
  Swaziland: {
    country: 'Swaziland',
    regex: /^[A-Za-z]\d{3}$/,
    errorMessage:
      'The postal code is invalid for country Swaziland, Swaziland postal code must be in M999 format. Example: M200',
  },
  Sweden: {
    country: 'Sweden',
    regex: /^(S-|SE-)?\d{3}\s?\d{2}$/,
    errorMessage:
      'The postal code is invalid for country Sweden, Sweden postal code must be in S-99999 OR SE-99999 OR 99999 OR 999 99 format. Example: S-11120 OR SE-11120 OR 11120 OR 111 20',
  },
  Switzerland: {
    country: 'Switzerland',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Switzerland, Switzerland postal code must be in 9999 format. Example: 3000',
  },
  Taiwan: {
    country: 'Taiwan',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Taiwan, Taiwan postal code must be in 99999 format. Example: 10001',
  },
  Tajikistan: {
    country: 'Tajikistan',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Tajikistan, Tajikistan postal code must be in 999999 format. Example: 734000',
  },
  Thailand: {
    country: 'Thailand',
    regex: /^\d{5}$/,
    errorMessage:
      'The postal code is invalid for country Thailand, Thailand postal code must be in 99999 format. Example: 10100',
  },
  'Trinidad and Tobago': {
    country: 'Trinidad and Tobago',
    regex: /^\d{6}$/,
    errorMessage:
      'The postal code is invalid for country Trinidad and Tobago, Trinidad and Tobago postal code must be in 999999 format. Example: 120110',
  },
  Tunisia: {
    country: 'Tunisia',
    regex: /^\d{4}$/,
    errorMessage:
      'The postal code is invalid for country Tunisia, Tunisia postal code must be in 9999 format. Example: 1000',
  },
  'United Kingdom': {
    country: 'United Kingdom',
    regex: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s?\d[A-Za-z]{2}$/,
    errorMessage:
      'The postal code is invalid for country United Kingdom, United Kingdom postal code must be in A(A)N(A/N)NAA OR A(A)N(A/N) NAA format. Example: SW1A 1AA OR EC1A 1BB',
  },
}

/** True if valid; true when no rule exists for `country` (caller treats as unrestricted). */
export const validatePostalCode = (
  country: string,
  postalCode: string
): boolean => {
  const validation = POSTAL_CODE_VALIDATIONS[country]
  if (!validation) return true
  return validation.regex.test(postalCode.trim())
}

//Returns the validation error message for a given country. Returns null if the country is not found.
export const getPostalCodeErrorMessage = (country: string): string | null => {
  const validation = POSTAL_CODE_VALIDATIONS[country]
  return validation?.errorMessage ?? null
}

//Returns a list of all supported country names.
export const getSupportedCountries = (): string[] => {
  return Object.keys(POSTAL_CODE_VALIDATIONS)
}

/**
 * Returns a canonical formatted postal code when the country has a defined formatter
 * and the value matches that country's regex from `POSTAL_CODE_VALIDATIONS`.
 * Otherwise returns null (caller should keep the raw input).
 */
export function formatPostalCodeForCountry(
  country: string,
  value: string | null | undefined
): string | null {
  const validation = POSTAL_CODE_VALIDATIONS[country]
  if (!value || typeof value !== 'string' || !validation) return null
  const trimmed = value.trim()
  if (!validation.regex.test(trimmed)) return null

  if (country === 'Ireland') {
    const stripped = trimmed.replace(/\s/g, '').toUpperCase()
    if (stripped.length !== 7) return null
    return `${stripped.slice(0, 3)} ${stripped.slice(3)}`
  }
  return null
}
